window.MarkupOrcamentoController = ControllerBase.extend({
    name: "MarkupOrcamentoController",

    framework: "knockout",

    ajax: function() {
        
        return {
            url: "/Orcamento/_Markup",
            type: "post",
            cache: false,
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento")
            }
        };

    },

    newModel: function() {

        return {
            Senha: null,
            Permitido: false,
            TamanhoGrid: "",
            Produtos: [],
            Valores: null
        };
    },

    renderizado: function() {
        this.redimensionarGridProdutos();
        $(window).resize($.proxy(this.redimensionarGridProdutos, this));
        $("[aside-direita-action]").click($.proxy(this.redimensionarGridProdutos, this));


        
    },

    redimensionarGridProdutos: function() {

        var removerWidth = 0;

        if (!$("[aside-direita-action]").hasClass("ativo")) {
            removerWidth = 252;
        }

        var width = $(window).width() - (($(window).width() <= 1200 ? 200 : 500) - removerWidth);

        this.model.TamanhoGrid(width + "px");
    },

    aposBinding: function() {

        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },

    formConfig: {
        selector: "#form-senha-markup",
        submit: {
            selector: "#entrar-markup",
            loadingText: "Aguarde...",
            callback: "entrar",
            type: "model",
            modelType: "knockout"
        },
        rules: {
            'Senha': {
                required: true
            }
        },
        messages: {
            'Senha': {
                required: 'O campo "Senha" é obrigatório.'
            }
        }

    },

    entrar: function(model, e) {

        if (e) {
            e.preventDefault();
        }

        if (!$(this.form).valid()) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/ObterMarkup",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                senha: this.model.Senha()
            }),
            success: function(data) {

                if (!data || data.HasErrors) {
                    return;
                }

                self.model.Permitido(true);
                self.model.Produtos(data.Produtos);
                self.model.Valores(data.Valores);


            }
        });

    },

    cancelar: function() {

    }

});